import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { DocumentIcon, FishIcons, PersonIcon, SpeedometerIcon } from './icons';

export default function StorageAutomation() {
	const t = useTranslation(TranslationNamespace.Marketing).t;
	return (
		<section className="storage-section3">
			<FishIcons />
			<div className="containerWarehouse">
				<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
					<h2
						className="section-title storage-section2-title"
						dangerouslySetInnerHTML={{
							__html: t('storage.storage-automation.automate-your-br-business-processes'),
						}}
					/>
					<p
						className="section-subtitle"
						dangerouslySetInnerHTML={{
							__html: t(
								'storage.storage-automation.free-up-time-from-routine-br-to-grow-and-prosper-your-enterprise',
							),
						}}
					/>
				</div>
				<div className="sm:mt-[6rem] mt-[3.5rem] flex sm:flex-row flex-col gap-[2.4rem]">
					<div className="storage-section2-card">
						<PersonIcon />
						<div>
							<h3>{t('storage.storage-automation.increase-customer-flow')}</h3>
							<p>
								{t(
									'storage.storage-automation.post-detailed-information-about-your-services-on-the-internet',
								)}
							</p>
						</div>
					</div>
					<div className="storage-section2-card">
						<SpeedometerIcon />
						<div>
							<h3>{t('storage.storage-automation.balance-the-load')}</h3>
							<p>
								{t(
									'storage.storage-automation.increase-storage-turnover-during-peaks-and-capacity-utilization-during-d',
								)}
							</p>
						</div>
					</div>
					<div className="storage-section2-card">
						<DocumentIcon />
						<div>
							<h3>{t('storage.storage-automation.reduce-costs')}</h3>
							<p>
								{t(
									'storage.storage-automation.fishplace-automation-will-eliminate-calls-unnecessary-approvals-and-spee',
								)}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
